/**
 * Brand theme — JS mirror of marketing-site-package/src/theme.ts
 */

export const colors = {
  void: '#0A0A0B',
  onyx: '#121215',
  pewter: '#1B1B20',
  steel: '#2A2A33',
  ash: '#8E8E97',
  bone: '#EDEAE2',
  paper: '#FFFFFF',
  champagne: '#E8D5A8',
  champagneSoft: '#F3E6C2',
  champagneDeep: '#D4BC85',
  gold: '#B8985F',
  goldDim: '#8A6F3F',
  amber: '#D4A249',
  scrim: 'rgba(10,10,11,0.78)',
  scrimDeep: 'rgba(10,10,11,0.92)',
  hairline: 'rgba(232,213,168,0.18)',
  hairlineSoft: 'rgba(232,213,168,0.08)',
  glassFill: 'rgba(20,20,23,0.55)',
};

export const spacing = { xs: 4, sm: 8, md: 16, lg: 24, xl: 40, xxl: 64, xxxl: 96 };
export const radius  = { none: 0, sm: 2, md: 4, lg: 8, pill: 999 };

export const typography = {
  wordmark: { family: '"Oswald", "Bebas Neue", "Helvetica Neue", sans-serif' },
  display:  { family: '"Cormorant Garamond", "Playfair Display", Georgia, serif' },
  body:     { family: '"Manrope", "Inter", "Helvetica Neue", sans-serif' },
  label:    { family: '"Manrope", "Helvetica Neue", sans-serif' },
  mono:     { family: '"JetBrains Mono", "IBM Plex Mono", ui-monospace, monospace' },
};

export const motion = { fast: 160, base: 280, slow: 520, easeOut: 'cubic-bezier(0.16, 1, 0.3, 1)' };

export const imagery = {
  brandLogoUrl: '/brand/blackops-logo.svg',
  brandLogoAspect: 925 / 385,
  // Hero — 2025/2026 refresh Cadillac Escalade (black), 3/4 front view showing
  // the new vertical LED front fascia. Confirmed model year via image analysis.
  heroPhoto:
    'https://images.unsplash.com/photo-1767749995474-cfb164d4d9ef?auto=format&fit=crop&w=2400&q=85',
  // Fleet — 2025/2026 refresh Cadillac Escalade (black), alternative angle
  fleetSuvPhoto:
    'https://images.unsplash.com/photo-1767749995458-b0927324e4d0?auto=format&fit=crop&w=1600&q=85',
  fleetSuvAltPhoto:
    'https://images.unsplash.com/photo-1767749995474-cfb164d4d9ef?auto=format&fit=crop&w=1600&q=85',
  // Fleet — Black Mercedes Sprinter van, cinematic (headlights on)
  fleetVanPhoto:
    'https://images.unsplash.com/photo-1765461734605-34657fa04db2?auto=format&fit=crop&w=1600&q=85',
  // Legacy alias kept for backwards compat
  fleetSedanPhoto:
    'https://images.unsplash.com/photo-1765461734605-34657fa04db2?auto=format&fit=crop&w=1600&q=85',
  heroOverlayGradient:
    'linear-gradient(180deg, rgba(10,10,11,0.55) 0%, rgba(10,10,11,0.65) 55%, rgba(10,10,11,1) 100%)',
  heroSideGradient:
    'linear-gradient(90deg, rgba(10,10,11,0.85) 0%, rgba(10,10,11,0.55) 45%, rgba(10,10,11,0.1) 100%)',
  grainNoiseDataURI:
    "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 240 240'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0.94 0 0 0 0 0.84 0 0 0 0 0.66 0 0 0 0.10 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
};
